import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./slice";

const selectDomain = (state) => state.assetDetails || initialState;

export const selectKitDetails = createSelector(
  [selectDomain],
  (state) => state.kitDetails
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectError = createSelector(
  [selectDomain],
  (state) => state.error
);

export const selectProjects = createSelector(
  [selectDomain],
  (state) => state.projects
);

export const selectEligibleOrders = createSelector(
  [selectDomain],
  (state) => state.eligibleOrders
);

export const selectSampleSealTypes = createSelector(
  [selectDomain],
  (state) => state.sealTypes
);